import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useDocumentSections } from '@terminal/react-query-hooks/documents/useDocumentsEntity';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { CitationsAccordionWidget } from '@terminal/widgets/citations-accordion-widget/CitationsAccordionWidget';
import { useTranslation } from 'react-i18next';

import sharedStyles from '../../ThemeExposureTab.module.scss';

export interface SourceEvidenceSectionProps {
  evidence?: string[] | null;
  sourceEvidence?: string | null;
  source: PosthogTrackingSource;
}

export const SourceEvidenceSection = ({
  evidence,
  sourceEvidence,
  source,
}: SourceEvidenceSectionProps) => {
  const { t } = useTranslation(['widget']);

  const { data, isFetching } = useDocumentSections(evidence ?? []);

  const getContent = () => {
    if (isFetching) {
      return (
        <SkeletonLoader
          areas={[
            { styles: { width: '100%', height: '180px', borderRadius: '8px' } },
          ]}
          data-testid="loading-skeleton"
        />
      );
    }

    return (
      <>
        {sourceEvidence && (
          <div className={sharedStyles.bodySmall} data-testid="evidence">
            {sourceEvidence}
          </div>
        )}
        <CitationsAccordionWidget
          citations={data}
          trackingMetadata={{ source }}
        />
      </>
    );
  };

  if (!sourceEvidence && !data.length && !isFetching) {
    return null;
  }

  return (
    <div className={sharedStyles.sectionRow}>
      <div className={sharedStyles.titleBase}>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.sourceEvidence'
        )}
      </div>
      {getContent()}
    </div>
  );
};
